import ColumnChart from "../Charts/ColumnChart";

const DashboardServiceOrdersChart = ({ dashBoardSummary, loading }) => {
    if (!dashBoardSummary?.ordersCountByService) return null;

    return (
        <>
            <h3 className="text-center my-5">
                Tipo de pedido por servicio
            </h3>
            <div className="row mb-5">
                {
                    Object.keys(dashBoardSummary?.ordersCountByService).length > 0 && !loading ?
                        <div className="col-md-12">
                            <ColumnChart
                                categories={Object.keys(dashBoardSummary?.ordersCountByService).map(key => dashBoardSummary?.ordersCountByService[key]?.service.toLocaleUpperCase())}
                                defaultSeries={[
                                    {
                                        name: 'Mensual',
                                        data: Object.keys(dashBoardSummary?.ordersCountByService).map(key => dashBoardSummary?.ordersCountByService[key]?.Mensual || 0),
                                        color: '#34b4db'
                                    },
                                    {
                                        name: 'Extraordinario',
                                        data: Object.keys(dashBoardSummary?.ordersCountByService).map(key => dashBoardSummary?.ordersCountByService[key]?.Extraordinario || 0),
                                        color: '#df6adb'

                                    },
                                    {
                                        name: 'Manual',
                                        data: Object.keys(dashBoardSummary?.ordersCountByService).map(key => dashBoardSummary?.ordersCountByService[key]?.Manual || 0),
                                        color: '#5e74f4'
                                    },
                                ]}
                            />
                        </div>
                        :
                        <h3 className="text-center text-danger">
                            No hay datos para mostrar.
                        </h3>
                }

            </div>
        </>
    );
};

export default DashboardServiceOrdersChart;
